/* eslint-disable */
const getters = {
  isLogin: state => state.call.isLogin,
  ImLogin: state => state.call.imLogin,
  engineerInfo: state => state.call.creactsessionPara,
  userInfo: state => state.call.userInfo, // 获取当前会话 用户信息
  sessions: state => state.call.defaultSession, // 获取当前会话 用户信息
  sessionId: state => state.call.sessionId,
  message: state => state.call.message, // 消息列表
  historyMsg: state => state.call.historyMsg, // 历史消息
  audioPlaying: state => state.call.audioPlaying,
  token: state => state.call.token,
  screen: state => state.call.screen,
  pwLoginInfo: state => state.loginInfo,
  userName: state => state.call.userInfo.user_name,
  sessionItem: state => state.call.historyMsgList,
  createSessionTime: state => state.call.startTime,
  isEngnineer: state => state.isEngnineer
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js